module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire",
      "standalone": ""
    }
  }, [(_vm.authenticated) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "persistent": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "teal",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-tile-action', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.role))]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.login))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "expand": ""
    }
  }, [_vm._l((_vm.menus), function(item, i) {
    return [(item.items) ? _c('v-list-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.menuCan(item)),
        expression: "menuCan(item)"
      }],
      key: item.name,
      attrs: {
        "group": item.group,
        "prepend-icon": item.icon,
        "no-action": "no-action"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "ripple": "ripple"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1), _vm._v(" "), _vm._l((item.items), function(subItem, i) {
      return [(subItem.items) ? _c('v-list-group', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.menuCan(subItem, item.group)),
          expression: "menuCan(subItem, item.group)"
        }],
        key: subItem.name,
        attrs: {
          "group": subItem.group,
          "sub-group": "sub-group"
        }
      }, [_c('v-list-tile', {
        attrs: {
          "slot": "activator",
          "ripple": "ripple"
        },
        slot: "activator"
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(subItem.title))])], 1)], 1), _vm._v(" "), _vm._l((subItem.children), function(grand, i) {
        return _c('v-list-tile', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.menuCan(grand, subItem.group)),
            expression: "menuCan(grand, subItem.group)"
          }],
          key: i,
          attrs: {
            "to": _vm.genChildTarget(item, grand),
            "href": grand.href,
            "ripple": "ripple"
          }
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(grand.title))])], 1)], 1)
      })], 2) : _c('v-list-tile', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.menuCan(subItem, item.group)),
          expression: "menuCan(subItem, item.group)"
        }],
        key: i,
        attrs: {
          "to": _vm.genChildTarget(item, subItem),
          "href": subItem.href,
          "disabled": subItem.disabled,
          "target": subItem.target,
          "ripple": "ripple"
        }
      }, [(subItem.icon) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(subItem.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(subItem.title))])])], 1), _vm._v(" "), (subItem.action) ? _c('v-list-tile-action', [_c('v-icon', {
        class: [subItem.actionClass || 'success--text']
      }, [_vm._v(_vm._s(subItem.action))])], 1) : _vm._e()], 1)]
    })], 2) : (item.header) ? _c('v-subheader', {
      key: i
    }, [_vm._v(_vm._s(item.header))]) : (item.divider) ? _c('v-divider', {
      key: i
    }) : _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.menuCan(item)),
        expression: "menuCan(item)"
      }],
      key: item.name,
      attrs: {
        "to": !item.href ? {
          name: item.name
        } : null,
        "href": item.href,
        "ripple": "ripple",
        "disabled": item.disabled,
        "target": item.target,
        "rel": "noopener"
      }
    }, [(item.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), (item.subAction) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "success--text"
    }, [_vm._v(_vm._s(item.subAction))])], 1) : _vm._e()], 1)]
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "indigo darken-4",
    attrs: {
      "fixed": "",
      "app": "",
      "dark": ""
    }
  }, [(_vm.authenticated) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_vm._v("TopUp Admin Panel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.screenWidth > 500) ? [(_vm.authenticated) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")]) : _vm._e()] : [(_vm.authenticated) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("fa-sign-out")])], 1) : _vm._e()]], 2), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "height": "auto",
      "inset": "",
      "color": "indigo darken-4"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": "",
      "white--text": "",
      "xs12": "",
      "body-2": ""
    }
  }, [_vm._v("\n        ©2018 —\n        "), _c('strong', [_vm._v("V:1.1.11 D:4:31 PM")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a5d04f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 683
// module chunks = 43